export default __webpack_public_path__ + "static/media/you_are_the_one.cf2878ca.png";